export default "__VITE_ASSET__Ci5z1xKf__"